// removed by extract-text-webpack-plugin
module.exports = {"member":"_38C4vSyFhMm2s2m8O69gMw","image":"_30AzHIBwIsEl-LkzBry9HJ","memberImage":"_WzTiUHC1mWfOK8A4i28W","info":"_3dBEtdguD7dwonFy4-pdEK","name":"_3TDtnl3NvWentcoN7akJwj","title":"_33yit5auvhb20ukqGooc7C","text":"_2Uq92FsopmseUdFT76eOPV","button":"wNvP-ZGSxZ2sbR11a4KlQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BoardMember/BoardMember.module.scss
// module id = 736
// module chunks = 0